import {createEntityAdapter, createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import moment from "moment/moment";
import apiClient from "../../../auth/apiClient";
import { createSelector } from "@reduxjs/toolkit";



export const ReportQueueStatus = {
    Processing : 1,
    UnknownError : 10,
    ReportServiceError : 11,
    FailedToSave : 12,
    Abandoned : 50,
    CanceledByCustomer : 60,
    CanceledByAdmin : 61,
    Completed : 100,
}
const isExpired = (value) => {
    if (!value) return true;
    const m = moment.utc(value);
    if (!m.isValid()) return true;
    return moment.utc().diff(m, 'hours') >= 72;
}

export const cancelReportJob = createAsyncThunk(
    "reportJobQueue/cancelReportJob",
    async ({ rqId ,rqStatusId, entityId } , thunkAPI) => {
        await apiClient.delete('reportqueue/cancelreport', {
            data: {
                rqId: rqId,
                RqStatusId: rqStatusId,
                entityId: entityId
            },
            headers: { "Content-Type": "application/json" },
        });
        return{ rqId ,rqStatusId, entityId };
    });

const reportJobQueueAdapter = createEntityAdapter({
    selectId: (job) => job.rqId,
    sortComparer: (a, b) => b.rqCreatedTime.localeCompare(a.rqCreatedTime)
});


const slice = createSlice({
    name: "reportJobQueue",
    initialState: reportJobQueueAdapter.getInitialState({
        isLoading: true,
        pendingFadeId: {},
    }),
    reducers: {
        setReportQueue: (state, action) => {


            const filtered= action.payload.filter((item) => {
                const status = item.rqStatusId;
                if (status === ReportQueueStatus.Completed || status === ReportQueueStatus.UnknownError) {
                    return !isExpired(item.rqCompletionTime);
                }
                return true;
            });
            state.isLoading = false;
            reportJobQueueAdapter.setAll(state, filtered);
        },
        updateReportStatus: (state, action) => {
            const {rqId, rqStatusId} = action.payload;
            const job = state.entities[rqId];

            if (!job) {
                return;
            }
            const newJob = {...job, rqStatusId};
            reportJobQueueAdapter.upsertOne(state, newJob);
        },
        completeReportStatus: (state, action) => {
            const {rqId, rqStatusId, rqCompletionTime} = action.payload;
            const job = state.entities[rqId];

            if (!job) {
                return;
            }
            const newJob = {...job, rqStatusId, rqCompletionTime};
            reportJobQueueAdapter.upsertOne(state, newJob);
        },
        addReportJob: (state, action) => {
            reportJobQueueAdapter.upsertOne(state, action.payload);
        },
        removeReportJob: (state, action) => {
            const {rqId} = action.payload;
            const job = state.entities[rqId];
            if (!job) {
                return;
            }
            reportJobQueueAdapter.removeOne(state, rqId);
        },
        markPendingFade: (state, action) => {
            const rqId = action.payload;
            state.pendingFadeId[rqId] = {
                ...state.pendingFadeId,
                [rqId]: true
            };
        },
        clearPendingFade: (state, action) => {
            const rqId = action.payload;
            delete state.pendingFadeId[rqId];
        }
    },
    extraReducers: (builder) => {
        builder.addCase(cancelReportJob.rejected, (state, action) => {
            console.warn("Failed to cancel report job");
        });
    }
});


export const baseSelectors = reportJobQueueAdapter.getSelectors(
    (state) => state.reportJobQueue
);

// Returns array of all report queue jobs in a array
export const selectReportQueue = baseSelectors.selectAll;
// Returns a single report queue job by id
export const selectReportQueueById = baseSelectors.selectById;
// returns total number of report queue jobs
export const selectReportQueueTotal = baseSelectors.selectTotal;
// Returns all report queue jobs look up table
export const selectReportQueueEntities = baseSelectors.selectEntities;

// Custom selector to count completed report jobs
export const selectCompletedReportJobsCount = createSelector(
    selectReportQueue,
    (reportJobs) => reportJobs.filter(job => job.rqStatusId === ReportQueueStatus.Completed).length
);
// Custom selector to count Queued report jobs
export const selectQueuedReportJobsCount = createSelector(
    selectReportQueue,
    (reportJobs) => reportJobs.filter(job => job.rqStatusId === null).length
);

export const selectErroredReportJobsCount = createSelector(
    selectReportQueue,
    (reportJobs) => reportJobs.filter(job => job.rqStatusId === ReportQueueStatus.UnknownError || job.rqStatusId === ReportQueueStatus.ReportServiceError || job.rqStatusId === ReportQueueStatus.FailedToSave).length
);


export const {
    setReportQueue,
    updateReportStatus,
    addReportJob,
    removeReportJob,
    completeReportStatus,
    markPendingFade,
    clearPendingFade
} = slice.actions;

export default slice.reducer;


